import { Routes, Route } from "react-router-dom";
import { IdentityProvider } from "./contexts/IdentityContext";
import { PlanProvider } from "./contexts/PlanContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Plan from "./pages/Plan";

export default function App() {
  return (
    <IdentityProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route
            path="p/:token"
            element={
              <PlanProvider>
                <Plan />
              </PlanProvider>
            }
          />
          <Route
            path="p/:token/*"
            element={
              <PlanProvider>
                <Plan />
              </PlanProvider>
            }
          />
        </Route>
      </Routes>
    </IdentityProvider>
  );
}
